/**
 * This is custom flag to handle edge case for `fire-coverage-buildings.js` transformer.
 * For more details check in this file.
 */
export default (kasko) => {
  kasko.addEventListener('route-changed', (changes) => {
    const currentPath = changes.current?.path;

    if (currentPath !== 'access-pin') {
      return;
    }

    kasko.dispatchEvent('set-state-input', {
      access_pin_flag: true,
    });
  });
};
